import { API_CONFIG, apiUtils } from '../config.js';

// School User Management API
export const userApi = {
  // Get all school users
  getAllUsers: async (filters = {}) => {
    const queryParams = apiUtils.buildQueryString(filters);
    const url = `${API_CONFIG.BASE_URL}/school-user/all${queryParams ? `?${queryParams}` : ''}`;
    return apiUtils.makeAuthenticatedRequest(url);
  },

  // Get user by ID
  getUserById: async (userId) => {
    const url = `${API_CONFIG.BASE_URL}/school-user/${userId}`;
    return apiUtils.makeAuthenticatedRequest(url);
  },

  // Create new user
  createUser: async (userData) => {
    const url = `${API_CONFIG.BASE_URL}/school-user/create`;
    return apiUtils.makeAuthenticatedRequest(url, {
      method: 'POST',
      body: JSON.stringify(userData),
    });
  },

  // Update user
  updateUser: async (userId, userData) => {
    const url = `${API_CONFIG.BASE_URL}/school-user/update/${userId}`;
    return apiUtils.makeAuthenticatedRequest(url, {
      method: 'PUT',
      body: JSON.stringify(userData),
    });
  },

  // Delete user
  deleteUser: async (userId) => {
    try {
      const token = localStorage.getItem('authToken');
      const headers = {
        ...(token && { 'Authorization': `Bearer ${token}` })
      };

      const response = await fetch(`${API_CONFIG.BASE_URL}/school-user/delete/${userId}`, {
        method: 'DELETE',
        headers
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
      }

      const text = await response.text();
      return text ? JSON.parse(text) : { success: true };
    } catch (error) {
      apiUtils.handleError(error);
      throw error;
    }
  },

  // Get current user profile (alias for me)
  getMe: async () => {
    const url = `${API_CONFIG.BASE_URL}/school-user/me`;
    return apiUtils.makeAuthenticatedRequest(url);
  },

  // Update current user profile
  updateMe: async (userData) => {
    const url = `${API_CONFIG.BASE_URL}/school-user/update-me`;
    return apiUtils.makeAuthenticatedRequest(url, {
      method: 'PUT',
      body: JSON.stringify(userData),
    });
  },

  // Change user password
  changePassword: async (passwordData) => {
    const url = `${API_CONFIG.BASE_URL}/school-user/change-password`;
    return apiUtils.makeAuthenticatedRequest(url, {
      method: 'POST',
      body: JSON.stringify(passwordData),
    });
  },
};

export default userApi;
